

export class MaintenanceTypeStatusInput implements IMaintenanceTypeStatusInput {
    /** The auto-generated id of the maintenance type master */
    maintenanceTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IMaintenanceTypeStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maintenanceTypeId = _data["maintenanceTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MaintenanceTypeStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTypeStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenanceTypeId"] = this.maintenanceTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IMaintenanceTypeStatusInput {
    /** The auto-generated id of the maintenance type master */
    maintenanceTypeId: number;
    /** The updated status */
    status: number;
}

